import { Feature } from '@weave/schema-gen-ts/dist/shared/feature/location_feature.pb';

export const SubscriptionFeatureToCFMap: Partial<Record<Feature, string>> = {
  [Feature.FORMS]: 'forms',
  [Feature.REVIEWS_HOME_ICON]: 'reviews',
  [Feature.CALL_INTELLIGENCE]: 'callintelligence',
  [Feature.ONLINE_SCHEDULING]: 'onlinescheduling',
  [Feature.PRACTICE_ANALYTICS]: 'practiceanalytics',
  [Feature.WEAVE_VERIFY]: 'weaveverify',
  [Feature.ENHANCED_INSURANCE_VERIFICATION]: 'enhancedinsuranceverification',
};
